import type { paths, components } from './openapi';
export * from './ApiError';
export * from './createApiClient';
export * from './createBrowserApiClient';
import { z } from 'zod/mini';

export type { components };

export type ApiInstant = components['schemas']['Instant'];
export type ApiURI = components['schemas']['URI'];
export type ApiLocalDate = components['schemas']['LocalDate'];
export type ApiBigInteger = components['schemas']['BigInteger'];
export type ApiBigDecimal = components['schemas']['BigDecimal'];
export type ApiCurrency = components['schemas']['Currency'];
// export type ApiMapFeeTypeApiTypesQuote = components['schemas']['Map-FeeType-ApiTypesQuote'];
// export type ApiMapTimeLimitUnitApiTypesQuote = components['schemas']['Map-TimeLimitUnit-ApiTypesQuote'];
export type ApiAuthChallengeRequired = components['schemas']['ApiTypesChallengesChallengeRequired'];
export type ApiOtpParams = components['schemas']['ApiTypesOtpParams'];
export type ApiAuthChallengeCompleted =
  components['schemas']['ApiTypesChallengesChallengesCompleted'];
export type ApiChallenge = components['schemas']['ApiTypesChallenges'];
export type ApiChallengeRequired = components['schemas']['ApiTypesChallengesChallengeRequired'];
export type ApiChallengeCompleted = components['schemas']['ApiTypesChallengesChallengesCompleted'];
export type ApiAuthRequest = components['schemas']['AuthResourceRequestsAuth'];
export type ApiToken = components['schemas']['ApiTypesToken'];
export type ApiAuthResourceAuthRefreshTokenRequest =
  components['schemas']['AuthResourceRequestsAuthRefreshToken'];
export type ApiOtpResourceOtpResendResponse =
  components['schemas']['OtpResourceResponsesOtpResend'];
export type ApiOtpResourceRequestsOtpResend = components['schemas']['OtpResourceRequestsOtpResend'];
export type ApiAccountResourceListAccountsResponse =
  components['schemas']['AccountResourceResponsesListAccounts'];
export type ApiAccount = components['schemas']['ApiAccountAccount'];
export type ApiMoney = components['schemas']['ApiTypesMoney'];
export type ApiAccountType = components['schemas']['CustomerAccountType'];
export type ApiAccountResourceAccountCreateRequest =
  components['schemas']['AccountResourceRequestsAccountCreate'];
export type ApiAccountUpdateNameRequest =
  components['schemas']['AccountResourceRequestsAccountUpdate'];
export type ApiAccountBalanceSummary = components['schemas']['ApiAccountBalanceSummary'];
export type ApiAccountResourceListAccountAddressesResponse =
  components['schemas']['AccountResourceResponsesListAccountAddresses'];
export type ApiAccountAddress = components['schemas']['AccountResourceResponsesAccountAddress'];
export type ApiAccountAddressWithMask = components['schemas']['AccountAddressWithMask'];
export type ApiAccountResourceCreateCryptoAccountAddressRequest =
  components['schemas']['AccountResourceRequestsCreateCryptoAccountAddress'];
export type ApiAccountResourceAccountProductResponse =
  components['schemas']['AccountResourceResponsesAccountProduct'];
export type ApiAccountProduct = components['schemas']['ApiAccountAccountProduct'];
export type ApiAccountProductConditions =
  components['schemas']['ApiAccountAccountProductConditions'];
export type ApiAccountProductUsage = components['schemas']['ApiAccountAccountProductUsage'];
export type ApiCustomerCurrentBusiness = components['schemas']['ApiCustomerCurrentBusiness'];
export type ApiCustomerBusiness = components['schemas']['ApiCustomerBusiness'];
export type ApiCustomerAddress = components['schemas']['ApiCustomerAddress'];
export type ApiCountryCode = components['schemas']['CountryCode'];
export type ApiIncorporationInfo = components['schemas']['ApiTypesIncorporationInfo'];
export type ApiIncorporationPlace = components['schemas']['ApiTypesIncorporationPlace'];
export type ApiCustomerKybStep = components['schemas']['ApiCustomerKybStep'];
export type ApiCustomerProfile = components['schemas']['ApiProfileCustomerProfile'];
export type ApiCustomerCurrentIndividual = components['schemas']['ApiCustomerCurrentIndividual'];
export type ApiCustomerIdentity = components['schemas']['ApiCustomerIdentity'];
export type ApiCustomerIndividual = components['schemas']['ApiCustomerIndividual'];
export type ApiBirthInfo = components['schemas']['ApiTypesBirthInfo'];
export type ApiBirthPlace = components['schemas']['ApiTypesBirthPlace'];
export type ApiCustomerName = components['schemas']['ApiCustomerName'];
export type ApiPromoPromo = components['schemas']['ApiPromoPromo'];
export type ApiPromoCampaign = components['schemas']['ApiPromoCampaign'];
export type ApiPromoRewardFreeCard = components['schemas']['ApiPromoRewardFreeCard'];
export type ApiPromoRewardMoney = components['schemas']['ApiPromoRewardMoney'];
export type ApiPromoRewardPromoActivation = components['schemas']['ApiPromoRewardPromoActivation'];
export type ApiPromoRewardVaultBonusYield = components['schemas']['ApiPromoRewardVaultBonusYield'];
export type ApiUInt = components['schemas']['UInt'];
export type ApiPromoOwnerRewardGoalReward = components['schemas']['ApiPromoOwnerRewardGoalReward'];
export type ApiPromoOwnerRewardRewardPerInvitee =
  components['schemas']['ApiPromoOwnerRewardRewardPerInvitee'];
export type ApiCustomerTermsAndConditions = components['schemas']['ApiCustomerTermsAndConditions'];
export type ApiCustomerProfileResourceProfileInfoUpdateRequest =
  components['schemas']['CustomerProfileResourceRequestsProfileInfoUpdate'];
export type ApiCustomerProfileResourceDisplayNameUpdateRequest =
  components['schemas']['CustomerProfileResourceRequestsDisplayNameUpdate'];
export type ApiCustomerProfileResourceUsernameUpdateRequest =
  components['schemas']['CustomerProfileResourceRequestsUsernameUpdate'];
export type ApiCustomerProfileResourceAboutUpdateRequest =
  components['schemas']['CustomerProfileResourceRequestsAboutUpdate'];
export type ApiCustomerProfileResourcePrivacyUpdateRequest =
  components['schemas']['CustomerProfileResourceRequestsPrivacyUpdate'];
export type ApiProfileUsernameResourceUsernameResponse =
  components['schemas']['ProfileUsernameResourceResponsesUsername'];
export type ApiBusinessKybResourceLegalTypeUpdateRequest =
  components['schemas']['BusinessKybResourceRequestsLegalTypeUpdate'];
export type ApiBusinessKybResourceLegalNameUpdateRequest =
  components['schemas']['BusinessKybResourceRequestsLegalNameUpdate'];
export type ApiBusinessKybResourceRegistrationNumberUpdateRequest =
  components['schemas']['BusinessKybResourceRequestsRegistrationNumberUpdate'];
export type ApiBusinessKybResourceIndustryUpdateRequest =
  components['schemas']['BusinessKybResourceRequestsIndustryUpdate'];
export type ApiBusinessKybResourceAddressUpdateRequest =
  components['schemas']['BusinessKybResourceRequestsAddressUpdate'];
export type ApiBusinessKybResourceIncorporationInfoUpdateRequest =
  components['schemas']['BusinessKybResourceRequestsIncorporationInfoUpdate'];
export type ApiBusinessKybResourceBusinessKybTokenResponse =
  components['schemas']['BusinessKybResourceResponsesBusinessKybToken'];
export type ApiExternalTransferChallengeRequired =
  components['schemas']['MakeExternalTransferUseCaseResponsesTransferChallengeRequired'];
export type ApiExternalTransferChallengeCompleted =
  components['schemas']['MakeExternalTransferUseCaseResponsesTransferChallengesCompleted'];
export type ApiTransactionState = components['schemas']['ApiTypesTransactionState'];
export type ApiTransaction = components['schemas']['ApiTransaction'];
export type ApiTransactionPart = components['schemas']['ApiTransactionPart'];
export type ApiBusinessBeneficiary =
  components['schemas']['ApiTransactionBeneficiaryBusinessBeneficiary'];
export type ApiCryptoBeneficiary =
  components['schemas']['ApiTransactionBeneficiaryCryptoBeneficiary'];
export type ApiIndividualBeneficiary =
  components['schemas']['ApiTransactionBeneficiaryIndividualBeneficiary'];
export type ApiBeneficiary =
  | ApiIndividualBeneficiary
  | ApiBusinessBeneficiary
  | ApiCryptoBeneficiary;
export type ApiNewBeneficiary = components['schemas']['NewBeneficiary'];
export type ApiGoalGoal = components['schemas']['ApiGoalGoal'];
export type ApiTransactionPayerAcquiringPayer =
  components['schemas']['ApiTransactionPayerAcquiringPayer'];
export type ApiTransactionPayerIndividualPayer =
  components['schemas']['ApiTransactionPayerIndividualPayer'];
export type ApiTransactionPayerOpenBankingPayer =
  components['schemas']['ApiTransactionPayerOpenBankingPayer'];
export type ApiTransactionTxnDate = components['schemas']['ApiTransactionTxnDate'];
export type ApiSide = components['schemas']['Side'];
export type ApiExternalTransferResponse =
  components['schemas']['MakeExternalTransferUseCaseResponsesTransfer'];
export type ApiExternalTransferRequest =
  components['schemas']['ExternalTransferResourceRequestsTransfer'];
export type ApiQuote = components['schemas']['ApiTypesQuote'];
export type ApiFees = Record<string, ApiQuote | undefined>;
export type ApiExternalTransferIntentResponse =
  components['schemas']['ExternalTransferResourceResponsesTransferIntent'];
export type ApiDeliveryInfo = components['schemas']['ApiTypesDeliveryInfo'];
export type ApiExternalTransferIntentRequest =
  components['schemas']['ExternalTransferResourceRequestsTransferIntent'];
export type ApiExternalTransferNetworkFormatResponse =
  components['schemas']['ExternalTransferResourceResponsesTransferNetworkFormat'];
export type ApiAccountAddressFormat = components['schemas']['ApiTypesAccountAddressFormat'];
export type ApiListApiTypesAccountAddressFormat =
  components['schemas']['List-ApiTypesAccountAddressFormat'];
export type ApiExternalTransferProviderResponse =
  components['schemas']['ExternalTransferResourceResponsesTransferProvider'];
export type ApiBeneficiaryResourceBeneficiaryListResponse =
  components['schemas']['BeneficiaryResourceResponsesBeneficiaryList'];
export type ApiTransactionListResponse =
  components['schemas']['TransactionResourceResponsesListTransactions'];
export type ApiAccountTransactionSummary = components['schemas']['ApiAccountTransactionSummary'];
export type ApiPayoutListResponse = components['schemas']['PayoutResourceResponsesGetPayouts'];
export type ApiPayout = components['schemas']['ApiPayoutPayout'];
export type ApiStrangeMoney = components['schemas']['Money'];
export type ApiPayoutResourcePayoutCreateRequest =
  components['schemas']['PayoutResourceRequestsPayoutCreate'];
export type ApiPayoutResourcePayoutUpdateRequest =
  components['schemas']['PayoutResourceRequestsPayoutUpdate'];
export type ApiPayoutPostponedResponse =
  components['schemas']['PayoutResourceResponsesTransferPostponed'];
export type ApiPayoutCreateTransferRequest =
  components['schemas']['PayoutResourceRequestsTransferCreate'];
export type ApiPayoutResourceExternalTransferCreateRequest =
  components['schemas']['PayoutResourceRequestsExternalTransferCreate'];
export type ApiStatement = components['schemas']['ApiTypesStatement'];
export type ApiConfigResourceCustomerSettingsResponse =
  components['schemas']['ConfigResourceResponsesCustomerSettings'];
export type ApiMarketingMarketing = components['schemas']['ApiMarketingMarketing'];
export type ApiProductProducts = components['schemas']['ApiProductProducts'];
export type ApiProductAccountProductCryptoAccountProduct =
  components['schemas']['ApiProductAccountProductCryptoAccountProduct'];
export type ApiProductAccountProductCondition =
  components['schemas']['ApiProductAccountProductCondition'];
export type ApiProductCryptoIncomingExternalTransferProduct =
  components['schemas']['ApiProductCryptoIncomingExternalTransferProduct'];
export type ApiProductCryptoIncomingExternalTransferProductCondition =
  components['schemas']['ApiProductCryptoIncomingExternalTransferProductCondition'];
export type ApiProductCryptoOutgoingExternalTransferProduct =
  components['schemas']['ApiProductCryptoOutgoingExternalTransferProduct'];
export type ApiProductCryptoOutgoingExternalTransferProductCondition =
  components['schemas']['ApiProductCryptoOutgoingExternalTransferProductCondition'];
export type ApiProductEarningVaultProduct = components['schemas']['ApiProductEarningVaultProduct'];
export type ApiProductEarningVaultProductCondition =
  components['schemas']['ApiProductEarningVaultProductCondition'];
export type ApiProductEarningVaultProductUsage =
  components['schemas']['ApiProductEarningVaultProductUsage'];
export type ApiVault = components['schemas']['ApiVaultVault'];
export type ApiVaultNextReward = components['schemas']['ApiVaultNextReward'];
export type ApiVaultType = components['schemas']['VaultsType'];
export type ApiVaultResourceListVaultsResponse =
  components['schemas']['VaultResourceResponsesListVaults'];
export type ApiProductAccountProductFiatAccountProduct =
  components['schemas']['ApiProductAccountProductFiatAccountProduct'];
export type ApiProductFiatIncomingExternalTransferProduct =
  components['schemas']['ApiProductFiatIncomingExternalTransferProduct'];
export type ApiProductFiatIncomingExternalTransferProductCondition =
  components['schemas']['ApiProductFiatIncomingExternalTransferProductCondition'];
export type ApiBankTransferNetworkId = components['schemas']['BankTransferNetworkId'];
export type ApiProductFiatOutgoingExternalTransferProduct =
  components['schemas']['ApiProductFiatOutgoingExternalTransferProduct'];
export type ApiProductFiatOutgoingExternalTransferProductCondition =
  components['schemas']['ApiProductFiatOutgoingExternalTransferProductCondition'];
export type ApiProductFxProduct = components['schemas']['ApiProductFxProduct'];
export type ApiProductCardProduct = components['schemas']['ApiProductCardProduct'];
export type ApiProductCardProductConditions =
  components['schemas']['ApiProductCardProductConditions'];
export type ApiProductCardProductUsage = components['schemas']['ApiProductCardProductUsage'];
export type ApiProductServiceProduct = components['schemas']['ApiProductServiceProduct'];
export type ApiProductTopUpProduct = components['schemas']['ApiProductTopUpProduct'];
export type ApiProductTopUpProductConditions =
  components['schemas']['ApiProductTopUpProductConditions'];
export type ApiCustomerCredentialsResourcePasswordSetRequest =
  components['schemas']['CustomerCredentialsResourceRequestsPasswordSet'];
export type ApiTypesChallenges = components['schemas']['Challenges'];
export type ApiCustomerCredentialsResourcePasswordUpdateRequest =
  components['schemas']['CustomerCredentialsResourceRequestsPasswordUpdate'];
export type ApiCustomerCredentialsResourceEmailSetResponse =
  components['schemas']['CustomerCredentialsResourceResponsesEmailSet'];
export type ApiCustomerCredentialsResourceEmailSetRequest =
  components['schemas']['CustomerCredentialsResourceRequestsEmailSet'];
export type ApiCustomerCredentialsResourceEmailConfirmRequest =
  components['schemas']['CustomerCredentialsResourceRequestsEmailConfirm'];
export type ApiCustomerCredentialsResourceEmailUpdateRequest =
  components['schemas']['CustomerCredentialsResourceRequestsEmailUpdate'];
export type ApiCustomerCredentialsResourcePhoneSetResponse =
  components['schemas']['CustomerCredentialsResourceResponsesPhoneSet'];
export type ApiCustomerCredentialsResourcePhoneSetRequest =
  components['schemas']['CustomerCredentialsResourceRequestsPhoneSet'];
export type ApiCustomerCredentialsResourcePhoneConfirmRequest =
  components['schemas']['CustomerCredentialsResourceRequestsPhoneConfirm'];
export type ApiCustomerCredentialsResourcePhoneUpdateRequest =
  components['schemas']['CustomerCredentialsResourceRequestsPhoneUpdate'];
export type ApiCustomerDetailedCustomer = components['schemas']['ApiCustomerDetailedCustomer'];
export type ApiCustomerRelation = components['schemas']['ApiCustomerRelation'];
export type ApiCustomerSocialCustomer = components['schemas']['ApiCustomerSocialCustomer'];
export type ApiVerificationFlowType = components['schemas']['ApiCustomerVerificationFlow'];

export type ApiDeveloperToken = components['schemas']['ApiTokenResourceResponsesIssuedApiToken'];
export type ApiDeveloperTokenInfo = components['schemas']['ApiTokenResourceResponsesApiTokenInfo'];

export type ApiCustomerWebhook = components['schemas']['CustomerWebhook'];
export type ApiEventToggles = components['schemas']['EventToggles'];
export type CustomerWebhooksId = components['schemas']['CustomerWebhooksId'];
export type CustomerWebhookResourceResponsesListWebhooks =
  components['schemas']['CustomerWebhookResourceResponsesListWebhooks'];
export type CustomerWebhookResourceRequestsCreateWebhook =
  components['schemas']['CustomerWebhookResourceRequestsCreateWebhook'];
export type CustomerWebhookResourceRequestsUpdateUri =
  components['schemas']['CustomerWebhookResourceRequestsUpdateUri'];
export type CustomerWebhookResourceRequestsUpdateSecret =
  components['schemas']['CustomerWebhookResourceRequestsUpdateSecret'];
export type CustomerWebhookResourceRequestsUpdateEvents =
  components['schemas']['CustomerWebhookResourceRequestsUpdateEvents'];

export type ApiCreatePayoutRequest =
  paths['/payouts']['post']['requestBody']['content']['application/json'];
export type ApiUpdatePayoutRequest =
  paths['/payouts/{id}']['patch']['requestBody']['content']['application/json'];

export type ApiCreatePayoutInternalTransferRequest =
  paths['/payouts/{id}/transfers/internal']['post']['requestBody']['content']['application/json'];

export type ApiCreatePayoutExternalTransferRequest =
  paths['/payouts/{id}/transfers/external']['post']['requestBody']['content']['application/json'];

export type ApiExecutePayoutRequest =
  paths['/payouts/{id}/execute']['post']['requestBody']['content']['application/json'];

export type ApiTransactionListRequestQuery = paths['/transactions']['get']['parameters']['query'];
export type ApiAccountListRequestQuery = paths['/accounts']['get']['parameters']['query'];

export type ApiSetPasswordRequest =
  paths['/businesses/current/password/set']['post']['requestBody']['content']['application/json'];

export type ApiSetEmailRequest =
  paths['/businesses/current/email/set']['post']['requestBody']['content']['application/json'];

export type ApiSetPhoneRequest =
  paths['/businesses/current/phone/set']['post']['requestBody']['content']['application/json'];

export type ApiConfirmPhoneRequest =
  paths['/businesses/current/phone/confirm']['post']['requestBody']['content']['application/json'];

export type ApiUpdatePhoneRequest =
  paths['/businesses/current/phone/update']['post']['requestBody']['content']['application/json'];

export type ApiConfirmEmailRequest =
  paths['/businesses/current/email/confirm']['post']['requestBody']['content']['application/json'];

export type ApiUpdateEmailRequest =
  paths['/businesses/current/email/update']['post']['requestBody']['content']['application/json'];

export type ApiCurrentBusinessResponse =
  paths['/businesses/current']['get']['responses']['200']['content']['application/json'];
export type ApiUpdateProfileInfoRequest =
  paths['/businesses/current/profileInfo']['patch']['requestBody']['content']['application/json'];

export type ApiChangeVerificationFlowRequest =
  paths['/businesses/current/kyb/change-verification-flow']['post']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessLegalNameRequest =
  paths['/businesses/current/legalName']['put']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessLegalTypeRequest =
  paths['/businesses/current/legalType']['put']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessIncorporationInfoRequest =
  paths['/businesses/current/incorporationInfo']['put']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessIndustryRequest =
  paths['/businesses/current/industry']['put']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessRegistrationNumberRequest =
  paths['/businesses/current/registrationNumber']['put']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessLegalAddressRequest =
  paths['/businesses/current/address']['put']['requestBody']['content']['application/json'];

export type ApiUpdateBusinessOperationalAddressRequest =
  paths['/businesses/current/operationalAddress']['put']['requestBody']['content']['application/json'];

export type ApiAccountCryptoAddressCreateRequest =
  paths['/accounts/{id}/addresses/crypto']['post']['requestBody']['content']['application/json'];

export type ApiCreateAccountRequest =
  paths['/accounts']['post']['requestBody']['content']['application/json'];

export type ApiOwnTransferCreateRequest =
  paths['/transfers/own']['post']['requestBody']['content']['application/json'];
export type ApiOwnTransferCreateResponse =
  paths['/transfers/own']['post']['responses']['200']['content']['application/json'];

export type ApiOwnTransferIntentRequest =
  paths['/transfers/own/intent']['post']['requestBody']['content']['application/json'];
export type ApiOwnTransferIntentResponse =
  paths['/transfers/own/intent']['post']['responses']['200']['content']['application/json'];

export type ApiInternalTransferIntentRequest =
  paths['/transfers/internal/outgoing/intent']['post']['requestBody']['content']['application/json'];
export type ApiInternalTransferIntentResponse =
  paths['/transfers/internal/outgoing/intent']['post']['responses']['200']['content']['application/json'];

export type ApiExternalOutgoingTransferCreateRequest =
  paths['/transfers/external/outgoing']['post']['requestBody']['content']['application/json'];
export type ApiExternalOutgoingTransferCreateResponse =
  paths['/transfers/external/outgoing']['post']['responses']['200']['content']['application/json'];

export type ApiInternalTransferCreateRequest =
  paths['/transfers/internal/outgoing']['post']['requestBody']['content']['application/json'];
export type ApiInternalTransferCreateResponse =
  paths['/transfers/internal/outgoing']['post']['responses']['200']['content']['application/json'];

export type ApiExternalOutgoingTransferIntentRequest =
  paths['/transfers/external/outgoing/intent']['post']['requestBody']['content']['application/json'];
export type ApiExternalOutgoingTransferIntentResponse =
  paths['/transfers/external/outgoing/intent']['post']['responses']['200']['content']['application/json'];

export type ApiExternalOutgoingCryptoNetworksQuery =
  paths['/transfers/external/outgoing/networks/crypto']['get']['parameters']['query'];
export type ApiExternalOutgoingFiatNetworkQuery =
  paths['/transfers/external/outgoing/network']['get']['parameters']['query'];
export type ApiExternalOutgoingFiatNetworkResponse =
  paths['/transfers/external/outgoing/network']['get']['responses']['200']['content']['application/json'];
export type ApiExternalOutgoingProviderQuery =
  paths['/transfers/external/outgoing/provider']['get']['parameters']['query'];
export type ApiExternalOutgoingProviderResponse =
  paths['/transfers/external/outgoing/provider']['get']['responses']['200']['content']['application/json'];

export type ApiUpdatePasswordRequest =
  paths['/businesses/current/password/update']['post']['requestBody']['content']['application/json'];

export type ApiCreateBusinessRequest =
  paths['/businesses']['post']['requestBody']['content']['application/json'];

export type ApiAccountStatementAvgBalanceQuery =
  paths['/accounts/{id}/statement/avg_balance']['get']['parameters']['query'];

export type ApiAccountStatementCSVQuery =
  paths['/accounts/{id}/statement/csv']['get']['parameters']['query'];

export type ApiPayoutTransfer =
  | components['schemas']['CryptoTransfer']
  | components['schemas']['FiatTransfer']
  | components['schemas']['InternalTransfer'];

export type ApiUploadFileResponse = {
  documents: Record<string, string>;
};

export type ApiMember = components['schemas']['ApiTypesCustomerMemberView'];

export type ApiMemberRole = components['schemas']['MembershipRole'];

export type ApiCard = components['schemas']['ApiCardCardView'];
export type ApiCardDesign = components['schemas']['ApiCardCardDesign'];
export type ApiCardOrderChallenge = components['schemas']['OrderCardUseCaseResponsesOrderResponse'];

export type ApiCardOrderRequest =
  paths['/cards/order']['post']['requestBody']['content']['application/json'];
export type ApiCardOrderResponse =
  paths['/cards/order']['post']['responses']['200']['content']['application/json'];

export type ApiCardActivateRequest =
  paths['/cards/{id}/activate']['post']['requestBody']['content']['application/json'];

export type ApiCardUpdateSecurityRequest =
  paths['/cards/{id}/security']['put']['requestBody']['content']['application/json'];

export type ApiCardUpdateSpendingLimitRequest =
  paths['/cards/{id}/spendingLimit']['put']['requestBody']['content']['application/json'];

export type ApiCardUpdateSpendingStrategyRequest =
  paths['/cards/{id}/spendingStrategy']['put']['requestBody']['content']['application/json'];

export type ApiCardRenameRequest =
  paths['/cards/{id}/rename']['put']['requestBody']['content']['application/json'];

export type ApiCardOrderIntentRequest =
  paths['/cards/order/intent']['post']['requestBody']['content']['application/json'];
export type ApiCardOrderIntentResponse =
  paths['/cards/order/intent']['post']['responses']['200']['content']['application/json'];

export type ApiCreateMember = components['schemas']['CustomerMembershipResourceRequestsMemberMeta'];

export type ApiMerchantInfo = {
  name: string;
  country: components['schemas']['CountryCode'];
  mcc: string;
  uri?: string;
};

export type ApiThreeDS = {
  id: string;
  cardOwner: string;
  requestId: string;
  merchantId?: string;
  merchantInfo: ApiMerchantInfo;
  amount: components['schemas']['ApiTypesMoney'];
  createdAt: string;
  lifeTimeInSec: number;
  cardToken: string;
  cardId: string;
  lastFour: string;
  type: string;
  approvedAt?: string;
  declinedAt?: string;
  declineReason?: string;
  state: 'PENDING' | 'APPROVED' | 'DECLINED';
};

export type ApiUpdateCustomerLegalInfo =
  components['schemas']['CustomerKycResourceRequestsLegalInfoUpdate'];

export type ApiCreateWebhookRequest =
  components['schemas']['CustomerWebhookResourceRequestsCreateWebhook'];

export type ApiStandingOrder =
  components['schemas']['StandingOrderResourceResponsesGetStandingOrderStandingOrder'];
export type ApiStandingOrderDestination =
  components['schemas']['StandingOrderResourceResponsesGetStandingOrderDestination']['destination'];
export type ApiCreateStandingOrderRequest =
  paths['/standingOrders']['post']['requestBody']['content']['application/json'];

export type ApiCreateStandingOrderDestinationRequest =
  paths['/standingOrders/{id}/destinations']['post']['requestBody']['content']['application/json'];

export type ApiUpdateStandingOrderRequest =
  paths['/standingOrders/{id}']['put']['requestBody']['content']['application/json'];

export type ApiUpdateStandingOrderStatusRequest =
  paths['/standingOrders/{id}/status']['put']['requestBody']['content']['application/json'];

export const ApiDigitalWalletTokenState = z.catch(
  z.enum(['PENDING', 'PROVISIONING', 'PROVISIONED', 'TERMINATED', 'UNKNOWN']),
  'UNKNOWN',
);

export type ApiDigitalWalletTokenState = z.infer<typeof ApiDigitalWalletTokenState>;

export const ApiDigitalWalletTokenRequestor = z.catch(
  z.enum(['APPLE_PAY', 'GOOGLE_PAY', 'OTHER']),
  'OTHER',
);

export type ApiDigitalWalletTokenRequestor = z.infer<typeof ApiDigitalWalletTokenRequestor>;

export const ApiDigitalWalletToken = z.object({
  id: z.string(),
  cardId: z.string(),
  state: ApiDigitalWalletTokenState,
  deviceName: z.nullish(z.string()),
  tokenRequestor: ApiDigitalWalletTokenRequestor,
  tokenRequestedAt: z.string(),
});

export type ApiDigitalWalletToken = z.infer<typeof ApiDigitalWalletToken>;

export const ApiDigitalWalletTokenResponse = z.object({
  digitalWalletToken: ApiDigitalWalletToken,
});

export const ApiDigitalWalletTokenListResponse = z.object({
  digitalWalletTokens: z.array(ApiDigitalWalletToken),
});

export type DeleteMemberRequest =
  paths['/businesses/current/members/remove']['post']['requestBody']['content']['application/json'];

export type ListMembersResponse =
  paths['/businesses/current/members']['get']['responses']['200']['content']['application/json'];

export type ApiVaultDepositRequest =
  paths['/vaults/{id}/deposit']['post']['requestBody']['content']['application/json'];
export type ApiVaultDepositResponse =
  paths['/vaults/{id}/deposit']['post']['responses']['200']['content']['application/json'];

export type ApiVaultDepositIntentRequest =
  paths['/vaults/{id}/deposit/intent']['post']['requestBody']['content']['application/json'];
export type ApiVaultDepositIntentResponse =
  paths['/vaults/{id}/deposit/intent']['post']['responses']['200']['content']['application/json'];

export type ApiVaultWithdrawRequest =
  paths['/vaults/{id}/withdraw']['post']['requestBody']['content']['application/json'];
export type ApiVaultWithdrawResponse =
  paths['/vaults/{id}/withdraw']['post']['responses']['200']['content']['application/json'];

export type ApiVaultWithdrawIntentRequest =
  paths['/vaults/{id}/withdraw/intent']['post']['requestBody']['content']['application/json'];
export type ApiVaultWithdrawIntentResponse =
  paths['/vaults/{id}/withdraw/intent']['post']['responses']['200']['content']['application/json'];
